import * as React from "react";
import { Box, Button, Container, Divider, Typography } from "@mui/material";

const books = [
  {
    title: "Sunchaser",
    series: "Book One of the Weatherworker Chronicles",
    cover: "/sunchaser_ebook_cover_cropped.jpg",
    alt: "Cover of Sunchaser by Emily Barlow",
    paragraphs: [
      "She can bend the weather to her will…but will it help her forge her own path?",
      "A small inland farm and a valley in the mountains are all Glorya has ever known. When she graduates from weatherworking school penniless, she must rely on her ingenuity and determination to make a name for herself. Her resourcefulness earns her a berth on a ship in exchange for protection against the foul weather that runs rampant off the coast.",
      "But the coastal weather–and the people who sail through it–are unlike anything Glorya has ever experienced. Soon she finds herself navigating both extreme weather and new cultures as she struggles to make a place for herself in the world.",
      "Will it be enough? Or will the raw power of nature combine with deadly foes to defeat her before she has a chance to prove herself?",
    ],
    link: "https://books.emilybarlowwritesthings.com/l3zn4nohsj",
    action: "Explore book options",
  },
  {
    title: "Stormkindler",
    series: "Book Two of the Weatherworker Chronicles",
    cover: "/stormkindler_2.jpeg",
    alt: "Cover of Stormkindler by Emily Barlow",
    paragraphs: [
      "Off the north coast of Midlands a fell wind blows, bringing with it a shadow and a threat. A ship carrying a dangerous crew waits to spring a trap that could change the fates of thousands. And none of them even know it exists.",
      "Glorya Sunchaser has made a name for herself across the known lands. Now she faces her next challenge: returning to school for the first time in years. She brings her niece, Zayira, who is of age to study at Weatherwatch, Midlands' premier--and only--weatherworking school, and Glorya has vowed to look after the child as if she were her own. Zayira's abilities don't fit into the molds the school has cast, and she fears for the girl's safety.",
      "One of them goes to learn; the other goes to fill the shoes of her beloved mentor, whose passage beyond this world has left a hole for the students and staff that no one else can fill. In his wake he leaves a mystery Glorya must race to solve before it falls into the wrong hands.",
      "Neither can see what waits for them in the dark.",
    ],
    link: "https://books.emilybarlowwritesthings.com/z43bdlpx2x",
    action: "Explore book options",
  },
  {
    title: "The Raven's Children",
    cover: "/the_ravens_children_cover_rework-2.jpeg",
    alt: "Cover of The Raven's Children by Emily Barlow",
    paragraphs: [
      "An ailing king. Three successors to the throne. A kingdom on the brink of turmoil.",
      "Ambjorg, Asbjorn, and Audolf watch as their father, King Hrafn, wastes away before their eyes. Figures lurk in the shadows, waiting for the right moment to strike and steal the crown. And all the while the three siblings and their father share a secret: an affinity with animals they use to keep their homeland safe.",
      "As tragedy strikes the royal family, reports of attacks by aberrant beasts start to trickle in. The siblings are split in many directions, thrust into new responsibilities that test their resolve and their bonds. It will take every skill and ally they have to best whomever--or whatever--is behind all the unrest. But will it be enough?",
      "Or will they lose both their kingdom and the lives of the ones they love?",
    ],
    link: "https://books.emilybarlowwritesthings.com/mghknnz1uj",
    action: "Explore book options",
  },
  {
    title: "Involuntarily Immortal",
    cover: "/Involuntarily_Immortal_cover_reworked_ebook-1.jpeg",
    alt: "Cover of Involuntarily Immortal by Emily Barlow",
    paragraphs: [
      "Sable Montgrief wishes her curse would let her die. Unfortunately for her, fate has other plans.",
      "Living alone in a cabin for decades, Sable has done her best to break the spell cast on her that has extended her life for centuries. She never wanted immortality; in fact, she's spent the majority of her long life trying to end it. Her latest attempt has her so close to breaking free she can taste it...until someone breaks down her door to find her.",
      "Adem Ozturk is looking for someone to help his daughter, Ailith, who is plagued with visions of the future she can neither manage nor interpret. They're on the run from an unknown organization with unlimited reach and are up against a wall–until Adem's wife sends a message to Ailith from beyond the grave, sending them to find Sable and recruit her to their cause. If they can convince her to help they may be able to not only save Ailith, but prevent a global cataclysm. The cost: another lifetime of torturous existence for Sable.",
      "If they fail, she'll be trapped in eternal torment; if they succeed, she'll still lose everything she loves.",
    ],
    link: "https://books.emilybarlowwritesthings.com/h3nnqnw79a",
    action: "Explore book options",
  },
  {
    title: "Gatekeeper, Spy",
    series: "Historical fiction · Coming January 2027",
    cover: "/gatekeeper-spy-cover.jpeg",
    alt: "Cover of Gatekeeper, Spy by Emily Barlow",
    paragraphs: ["A historical fiction novel by Emily Barlow, available for preorder ahead of its January 2027 release."],
    link: "https://books.emilybarlowwritesthings.com/sqdu2suhoa",
    action: "Preorder Gatekeeper, Spy",
  },
];

export default function ProductHeroBooks() {
  return (
    <Box
      component="section"
      id="books"
      aria-labelledby="books-heading"
      sx={{
        py: { xs: 6, md: 10 },
        color: "common.white",
        backgroundImage:
          "linear-gradient(rgba(0,0,0,.78), rgba(0,0,0,.78)), url('/books_section_background.png')",
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
    >
      <Container maxWidth="lg">
        <Typography
          id="books-heading"
          component="h2"
          variant="h2"
          align="center"
          sx={{ mb: { xs: 4, md: 6 } }}
        >
          Books
        </Typography>

        <Box>
          {books.map((book, index) => (
            <React.Fragment key={book.title}>
              <Box
                component="article"
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  alignItems: { xs: "center", sm: "flex-start" },
                  gap: { xs: 3, sm: 4, md: 5 },
                  py: { xs: 4, md: 5 },
                }}
              >
                <Box
                  component="img"
                  src={book.cover}
                  alt={book.alt}
                  loading="lazy"
                  sx={{
                    display: "block",
                    flex: "0 0 auto",
                    width: { xs: 180, sm: 190, md: 220 },
                    maxWidth: "100%",
                    height: { xs: 250, sm: 280, md: 320 },
                    objectFit: "contain",
                    filter: "drop-shadow(0 5px 12px rgba(0,0,0,.45))",
                  }}
                />

                <Box
                  sx={{
                    flex: "1 1 auto",
                    minWidth: 0,
                    width: "100%",
                    textAlign: { xs: "center", sm: "left" },
                  }}
                >
                  <Typography component="h3" variant="h4" gutterBottom>
                    {book.title}
                  </Typography>

                  {book.series && (
                    <Typography
                      variant="subtitle1"
                      sx={{ mb: 2, color: "secondary.main" }}
                    >
                      {book.series}
                    </Typography>
                  )}

                  {book.paragraphs.map((paragraph, paragraphIndex) => (
                    <Typography
                      key={paragraphIndex}
                      variant="body1"
                      paragraph
                      sx={{ lineHeight: 1.7 }}
                    >
                      {paragraph}
                    </Typography>
                  ))}

                  <Button
                    component="a"
                    href={book.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="contained"
                    aria-label={`${book.action} on BookFunnel`}
                    sx={{ mt: 1 }}
                  >
                    {book.action}
                  </Button>
                </Box>
              </Box>

              {index < books.length - 1 && (
                <Divider
                  sx={{
                    borderColor: "rgba(255,255,255,.35)",
                    maxWidth: "100%",
                  }}
                />
              )}
            </React.Fragment>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
